import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import qs from 'qs';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import includes from 'lodash/includes';
import {Redirect} from 'react-router-dom';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import setDisplayName from 'recompose/setDisplayName';
import {resourcesSelector} from 'resources/selectors';
import {saveResourceFieldAction, refreshPageAction} from 'resources/actions';
import {startCopyPrizeAction} from 'pages/PrizeCopy/actions';
import {startDeleteAction} from 'pages/DeleteConfirmation/actions';
import CopyPrizeModalContainer from 'pages/PrizeCopy/CopyPrizeModalContainer';
import {getUserResourceActions, getUserServiceActions} from 'pages/Profile/selectors';
import * as ResourceApi from 'api/resources';
import EditPrizePage from './EditPrizePage';
import {extractResourceIdsWithPath, RestrictedUserGroups} from 'utils/DBUtils';
import {
  requestPrizeAction,
  unmountPrizeAction,
  publishPrizeSubmitAction,
  closePublishPrizeModalAction
} from './actions';

const getPrizeResourceActions = getUserResourceActions(ResourceApi.Types.PublishedPrize);
const getPrizeServiceActions = getUserServiceActions(ResourceApi.Types.PublishedPrize);

const mapStateToProps = (state, ownProps) => {
  const {
    currentPrizeId,
    isRelatedPrize,
    isPublishPrizeModalOpen,
    prizeWasPublished,
    prizePublishErrors
  } = state.editPrize;

  const prize = get(resourcesSelector(state.resources), currentPrizeId, null);
  const prizeWasDeleted = prize && isEqual(state.deleteConfirmation.lastResourceIdDeleted, prize.resourceId);

  const {openSection} = qs.parse(ownProps.location.search.slice(1));

  const userCanPublishPrizes = includes(getPrizeServiceActions(state), 'PUBLISH_PRIZE');
  const userCanDeletePrizes = includes(getPrizeResourceActions(state), 'DELETE');

  return {
    userCanPublishPrizes,
    userCanDeletePrizes,
    reducerKey: 'editPrize',
    openSection,
    prize,
    isRelatedPrize,
    isPublishPrizeModalOpen,
    prizeWasPublished,
    prizePublishErrors,
    currentPrizeId,
    prizeWasDeleted
  };
};

const mapDispatchToProps = {
  getPrize: requestPrizeAction,
  clearPrize: unmountPrizeAction,
  showCopyPrizeModal: startCopyPrizeAction,
  publishPrize: publishPrizeSubmitAction,
  closePublishPrizeModal: closePublishPrizeModalAction,
  showDeletePrizeConfirmation: prize => startDeleteAction(
    prize,
    prize.resourceId,
    [],                                          // additional resource ids
    {},                                          // additional data
    [refreshPageAction(ResourceApi.Types.Prize)] // post actions
  )
};

const EditPrizePageContainer = compose(
  setDisplayName('EditPrizePageContainer'),
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentWillMount() {
      this.props.getPrize(this.props.match.params.prizeId);
    },

    componentWillReceiveProps(nextProps) {
      const urlPrizeId = nextProps.match.params.prizeId;
      const currentPrizeIsStale = urlPrizeId !== nextProps.currentPrizeId;

      // re-fetch after copying a prize, but not when navigating to a related prize
      if (currentPrizeIsStale && !nextProps.isRelatedPrize) {
        this.props.getPrize(urlPrizeId);
      }

      // redirect to prizing dashboard after deleting a prize
      if (nextProps.prizeWasDeleted) {
        this.props.history.push('/prizes');
      }
    },

    componentWillUnmount() {
      this.props.clearPrize();
    }
  })
)(EditPrizePage);

const EditPrizeRedirectContainer = connect(state => {
  const {isRelatedPrize, currentPrizeId} = state.editPrize;
  return {
    isRelatedPrize,
    currentPrizeId
  };
})(props => props.isRelatedPrize && (
  <Redirect to={`/prize/${props.currentPrizeId}/edit?openSection=editPrizeSection`} />
));

export default routerProps => (
  <Fragment>
    <EditPrizePageContainer {...routerProps} />
    <EditPrizeRedirectContainer />
    <CopyPrizeModalContainer />
  </Fragment>
);



// WEBPACK FOOTER //
// ./public/pages/EditPrize/EditPrizePageContainer.jsx